export default {
  data() {
    return {
      cards: [],
    };
  },
  computed: {
    items() {
      return this.myOrder && this.myOrder.product && this.myOrder.product.items
          ? this.myOrder.product.items : null;
    },
  },
  methods: {
    next(i, setPrevStep = true) {
      const product = this.items[i];

      if (product.variants && product.variants.length > 0) {
        if (setPrevStep) {
          this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
        }
        this.$store.dispatch('SET_PRODUCT_ITEM', product);
        this.$store.dispatch('SET_ORDER_STEP', `${this.orderStep}-confirm`);
      }
    },
  },
  created() {
    this.$store.dispatch('SET_PRODUCT_VARIANT_ID', null);

    this.items.forEach((item) => {
      this.cards.push({
        show: true,
        price: parseFloat(this._.minBy(item.variants, 'price').price),
        name:this._.minBy(item.variants, 'price').name,
      });
    });

    if (this.cards.length === 1) {
      this.next(0, false);
    }
  },
};
